import { render, staticRenderFns } from "./ShipperConsignee.vue?vue&type=template&id=9ed8ecda&scoped=true&"
import script from "./ShipperConsignee.vue?vue&type=script&lang=js&"
export * from "./ShipperConsignee.vue?vue&type=script&lang=js&"
import style0 from "./ShipperConsignee.vue?vue&type=style&index=0&id=9ed8ecda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed8ecda",
  null
  
)

export default component.exports